<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col class="mb-1">
          <div class="btn-group float-left">
            <router-link
              tag="button"
              class="btn btn-sm btn-warning"
              :to="{ name: 'EXCMRelationCategoryUpdate', params: { id: retrieved['@id'] }}"
            >{{$t('buttons.edit')}}</router-link>
            <button type="button" class="btn btn-sm btn-danger" @click="deleteItem(retrieved)">
              {{$t('buttons.delete')}}
            </button>
          </div>
          <router-link
            :to="{ name: 'EXCMRelationCategoryList' }"
            class="btn btn-sm btn-default float-right"
          >{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="isLoading">
            <Loader />
          </div>
          <div v-else>
            <b-card>
              <b-row>
                <b-col cols="12">
                  <p v-if="retrieved.title">{{ $t('views.documenttype.list.title') }}:
                    <b>{{retrieved.title}}</b></p>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'Show',
  components: {
    Loader
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      retrieved: 'excmrelationcategory/show/retrieved',
      isLoading: 'excmrelationcategory/show/isLoading'
    })
  },
  created () {
    this.retrieve(this.id)
  },
  methods: {
    ...mapActions({
      retrieve: 'excmrelationcategory/show/retrieve',
      del: 'excmrelationcategory/del/del'
    }),
    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item['@id']).then(() => this.$router.push({ name: 'EXCMRelationCategoryList' }))
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
